import { StyledAppAnimateWhileTap } from "./index.styled";
import PropTypes from "prop-types";

const AppAnimateWhileTap = (props) => {
  const { children, fullHeight, fullWidth, onClick } = props;
  return (
    <StyledAppAnimateWhileTap
      full_height={`${fullHeight}`}
      full_width={`${fullWidth}`}
      whileTap={{
        scale: 0.9,
        x: "-5px",
        y: "5px",
      }}
      onClick={onClick}
    >
      {children}
    </StyledAppAnimateWhileTap>
  );
};

AppAnimateWhileTap.propTypes = {
  children: PropTypes.node.isRequired,
  fullHeight: PropTypes.bool,
  fullWidth: PropTypes.bool,
  onClick: PropTypes.func,
};

AppAnimateWhileTap.defaultProps = {
  fullHeight: false,
  fullWidth: false,
  onClick: null,
};

export default AppAnimateWhileTap;
